import { Globe } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

interface LinkedToGlobalChipProps {
  usageCount?: number | null
  className?: string
}

/**
 * Phase 15 — small "Linked" pill rendered next to per-project catalog rows + inventory rows
 * that are bound to a global entry. Tooltip shows the cross-project usage count when known.
 */
export const LinkedToGlobalChip = ({ usageCount, className }: LinkedToGlobalChipProps) => {
  const tooltip =
    typeof usageCount === 'number' && usageCount > 0
      ? `Linked · used in ${usageCount} ${usageCount === 1 ? 'project' : 'projects'}`
      : 'Linked to shared catalog'
  return (
    <Badge
      variant="secondary"
      className={cn('inline-flex items-center gap-1 text-[10px]', className)}
      title={tooltip}
    >
      <Globe className="h-3 w-3" aria-hidden />
      Linked
    </Badge>
  )
}
